import type { FormVariant } from '../types';
import { radVariant } from './radVariant';
import { simpleVariant } from './simpleVariant';

const VARIANTS_BY_DRILLDOWN_TYPE: Record<number, FormVariant> = {
    21: radVariant,
    1: simpleVariant,
    22: simpleVariant,
};

const DEFAULT_VARIANT: FormVariant = simpleVariant;

export function getVariant(drilldownTypeId: number): FormVariant {
    return VARIANTS_BY_DRILLDOWN_TYPE[drilldownTypeId] ?? DEFAULT_VARIANT;
}
